<rt-dropdown-header>
  @if (hasBackAction) {
    <rt-icon-button
      prefix
      (click)="goBack.emit($event)"
      variant="plain"
      iconName="keyboard-backspace"
      shape="square"
      size="small"
    />
  }
  <span>
    {{ label }}
  </span>
  @if (hasSettings) {
    <rt-icon-button
      suffix
      (click)="goToSettings.emit($event)"
      variant="plain"
      iconName="settings"
      shape="square"
      size="small"
    />
  }
</rt-dropdown-header>
<div>
  @if (hasSearch) {
    <rt-form-field class="context-default" padding-tb-small-x padding-lr-small>
      <rt-input
        [value]="searchQuery"
        [autoFocus]="true"
        [hasClearButton]="true"
        (focus)="onFocusChanges(true)"
        (blur)="onFocusChanges(false)"
        (valueChange)="searchQueryChange.emit($event)"
        variant="rounded"
        [placeholder]="searchPlaceholder"
      >
        <rt-icon prefix name="search" />
      </rt-input>
    </rt-form-field>
  }
</div>
